export enum SectionEnum {
  FOOTER = 'footer',
}
